module.exports = __webpack_public_path__ + "static/media/lancer.dd2cf04d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/mitsubishi/lancer.jpg
// module id = 749
// module chunks = 0